/** Policy documents the legacy BYOD and MetLife pages link to (hosted on the company SharePoint). */
export const SERVICE_DESK_URLS = {
  devicePolicy:
    'https://selisech-my.sharepoint.com/:f:/r/personal/adnan_raihan_selisegroup_com/Documents/HR%20360/Device%20Policy?csf=1&web=1&e=hvEiS4',
  metlifePolicy:
    'https://selisech-my.sharepoint.com/shared?id=%2Fpersonal%2Fadnan%5Fraihan%5Fselisegroup%5Fcom%2FDocuments%2FHR%20360%2FMetLife%20Insurance&listurl=%2Fpersonal%2Fadnan%5Fraihan%5Fselisegroup%5Fcom%2FDocuments&viewid=f095d37c%2D64ba%2D463b%2D8992%2Dcf00f0fc7310&csf=1&FolderCTID=0x01200010D132D9D916AD43AEC755C6867A3B5A',
};
